function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useField, useFormikContext } from 'formik';
import React from 'react';
import { FormFeedback } from 'reactstrap';
export default (function (_ref) {
  var name = _ref.name,
      props = _objectWithoutProperties(_ref, ["name"]);

  var _useFormikContext = useFormikContext(),
      submitCount = _useFormikContext.submitCount;

  var data = useField(name);
  var _data$ = data[1],
      touched = _data$.touched,
      error = _data$.error; // if nothing happen and no error occured, and u check here, its probably a missing field.

  if ((touched || submitCount > 0) && typeof error === 'string') {
    return /*#__PURE__*/React.createElement(FormFeedback, props, error);
  }

  return null;
});